module.exports = __webpack_public_path__ + "img/2.a5dc1ab6.png";